function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialEmail = function SvgSocialEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.569-.435v.026a.168.168 0 0 0-.105-.035c-.105 0-.192.085-.192.204 0 .117.087.203.192.203a.19.19 0 0 0 .132-.051.152.152 0 0 0 .126.059c.117 0 .194-.1.194-.254 0-.233-.191-.394-.423-.394a.433.433 0 0 0-.446.439c0 .253.188.429.451.429A.472.472 0 0 0 .731.135L.689.05A.391.391 0 0 1 .5.094C.293.094.154-.04.154-.24c0-.198.139-.339.34-.339.181 0 .32.114.32.307 0 .102-.037.155-.087.155-.033 0-.053-.022-.053-.065v-.253H.569ZM.48-.133C.421-.133.378-.175.378-.24c0-.066.043-.108.102-.108.032 0 .065.012.089.04v.135a.115.115 0 0 1-.089.04Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(21.77902 0 0 21.77902 1.98 17.744)"
  }));
};
export default SvgSocialEmail;